


































































































    import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'

     


    import PageRequest from '@/store/entities/page-request'
  
     //入库统计
    class PageordermanagementRequest extends PageRequest{
        keyword:string='';
        stime:string;
        etime:string;
        ordtime: string[] = [];
        status:number=-1;
        type:number=1;
        listcid:string;
        province:string='';
        city:string='';
        county:string='';
        villages:string='';
        querytype:number=1;
    }
    
    @Component({
       // components:{CreateOrderManagement,Editordermanagement}
    })
    export default class ordermanagementwarehousing extends AbpBase{
       
      // creationTime:Date []=[];
        cflistid:any=[]
        isckd:boolean=false;
        weight_all:string="0";
        num_all:number=0;
        pagerequest:PageordermanagementRequest=new PageordermanagementRequest();
        
        
        cleartimeChange(){
        this.pagerequest.ordtime=[];
      }

      handleDateChange(val){
       this.pagerequest.ordtime=val;
      }
  
        get list(){
           //   
           var allnum=0;
           var allweight=0;
            var lt=this.$store.state.ordermanagement.ykcflist;

            lt.forEach(itme=>{
                                    var weight=itme.weight;
                                    var count=itme.count;
                                    allnum+=count;
                                    allweight+=weight;
                                      
                            });
                      this.num_all=allnum;
                      this.weight_all= parseFloat(allweight.toString()).toFixed(3); 

            return lt;
        };

        get loading(){
            return this.$store.state.ordermanagement.loading;
        }
        

         async getCompanyInformation_All(){

              await this.$store.dispatch({
                type:'ordermanagement/getCompanyInformation',
                
            }).then(x=>{
              this. cfcheckinfo();
              this.cfcheckall(true);
                this.getpage();
            })
            
        }
          async GetRegionAlList(){
            
            
            await this.$store.dispatch({
                type:'companyinformation/getRegionAlList',
                 
            })
        }
          
        get provicelist(){
             var list=[];
             var lets  = this.$store.state.companyinformation.regionlist;

              
               
           
            if(lets!=undefined&&lets.length>0){
               for(var i=0;i<lets.length;i++){
                  
               var province= lets[i].province;
                list.push(province);
                      
               }
               }
          return list;
        }
        get citylist(){
            return  this.$store.state.companyinformation. citylist
        }
        set citylist(val:object){

                this.$store.commit("companyinformation/change_citylist", val);
        }

        get countylist(){
                return  this.$store.state.companyinformation. countylist
        }
        set countylist(val:object){

                this.$store.commit("companyinformation/change_countylist", val);
        }
         get villageslist(){
                return  this.$store.state.companyinformation. villageslist
        }
        set  villageslist(val:object){

                this.$store.commit("companyinformation/change_villageslist", val);
        }

        

         provinceChange(val:number){
            this.$store.state.citylist=[];
            var selectedprovince= val;
            var list=[];
            var lets  = this.$store.state.companyinformation.regionlist;
            console.log(lets)
               for(var i=0;i<lets.length;i++){
                  
                 var province= lets[i].province;
                if(selectedprovince==province){
                       var lstct=lets[i].citylist;
                        lstct.forEach(item=>{
                            list.push( item.city)
                        });
                         

                }
               }
                
                this.citylist=list;       
         }

          cityChange(val:number){
            this.$store.state.county=[];
            var selectedvue= val;
            var list=[];
            var lets  = this.$store.state.companyinformation.regionlist;
            console.log(lets)
               for(var i=0;i<lets.length;i++){
                  
                 var province= lets[i].province;
                
                       var lstct=lets[i].citylist;
                        lstct.forEach(item=>{
                             
                             var city=item.city;
                             if(selectedvue==city){
                             var countylist=item.countylist;
                            countylist.forEach(item_county=>{
                                    var county=item_county.county;
                                    list.push(county);
                                      
                            });
                             }
                        });
                         

                
               }
               
                
                this.countylist=list;       
         }

           countyChange(val:number){
            this.$store.state.county=[];
            var selectedvue= val;
            var list=[];
            var lets  = this.$store.state.companyinformation.regionlist;
            console.log(lets)
               for(var i=0;i<lets.length;i++){
                  
                 var province= lets[i].province;
                
                       var lstct=lets[i].citylist;
                        lstct.forEach(item=>{
                             
                             var city=item.city;
                           
                             var countylist=item.countylist;
                            countylist.forEach(item_county=>{

                                    var county=item_county.county;
                                    var villageslist=item_county.villageslist;
                                    if(selectedvue==county){
                                        villageslist.forEach(item_vill=>{

                                         list.push(item_vill.villages);
                                        })

                                    }
                            });
                             
                        });
                         

                
               }
                
                
                this.villageslist=list;       
         }
        
        


         cfcheckall(val){
             
            
            if(!val){
                this. cflistid=[];
                    
            }else{
             //   
                 this.isckd=true;
              
               // this.$store.state.ordermanagement.cflistid=this.cflistid;
               if( this.$store.state.ordermanagement.cflistid.length<=0){
                    this.cfcheckinfo()

               }

                this. cflistid=  this.$store.state.ordermanagement.cflistid
            }
        

        }
        cfcheckinfo(){
                   var lt=[];
              var cflt= this.$store.state.ordermanagement.companyinformations

                  cflt.forEach(item=>{
                    lt.push( item.name);
               }
             )
             this.$store.state.ordermanagement.cflistid=lt;
        }
        tabck(val:string){
            this.pagerequest.querytype=1;
           if(val=="name2"){
this.pagerequest.querytype=2;
           }
           
             
        }
       

        pageChange(page:number){
            this.$store.commit('ordermanagement/setCurrentPage',page);
            this.getpage();
        }
        pagesizeChange(pagesize:number){
            this.$store.commit('ordermanagement/setPageSize',pagesize);
            this.getpage();
        }
        async getpage(){
                
             debugger
              var lstinf= this.cflistid
             var listcid=[];
            if(lstinf.length>0){
                 
                 var cflt= this.$store.state.ordermanagement.companyinformations
                
                  cflt.forEach(item=>{
                     
                        lstinf.forEach(itemck=>{
                            if(itemck==item.name){
                                    listcid.push( item.id);
                            }
                   
                    })
               })
                 
                 this.pagerequest.listcid=listcid.toString();
              }
              if(listcid.length<=0){

                this.$Message.error('请选择公司名称');
                return false;
              }



     this.pagerequest.type=1;
             
     var starttime=""; 
     var endtime ="";
     if (this.pagerequest.ordtime.length > 0) {
       starttime=this.pagerequest.ordtime[0];
    }
    if (this.pagerequest.ordtime.length > 1) {
     endtime =this.pagerequest.ordtime[1];
    }
     this.pagerequest.stime=starttime;
     this.pagerequest.etime=endtime;
            
            await this.$store.dispatch({
                type:'ordermanagement/getStatisticsDataCompanyInformationTimeInput',
                data:this.pagerequest
            })
        }
         



        get pageSize(){
            return this.$store.state.ordermanagement.pageSize;
        }
        get totalCount(){
            return this.$store.state.ordermanagement.totalCount;
        }
        get currentPage(){
            return this.$store.state.ordermanagement.currentPage;
        }
        columns=[{
            title:this.L('CompanyinformationName'),
            key:'name'
        }
        ,{
            title:this.L('CompanyinformationProvince'),
            key:'province'
        },{
            title:this.L('CompanyinformationCity'),
            key:'city'
        },{
            title:this.L('CompanyinformationCounty'),
            key:'county'
        },{
            title:this.L('CompanyinformationVillages'),
            key:'villages'
        }
       
        ,{
            title:this.L('OrderWeightALL'),
            key:'weight',
            
        }

         ,{
            title:this.L('OrderNumALL'),
            key:'count',
            
        }
        
]
         async created(){
          debugger
           // this .pagerequest.type=1;
          // this.$store.state.ordermanagement.type=1;
           this.GetRegionAlList()
           this.getCompanyInformation_All();

            
           // this. isckd=true;
             
           
           
        }
 
    async xlsximpt() {

            var lstinf= this.cflistid
              if(lstinf.length>0){
                 
                 var cflt= this.$store.state.ordermanagement.companyinformations
                 var listcid=[];
                  cflt.forEach(item=>{
                     
                        lstinf.forEach(itemck=>{
                            if(itemck==item.name){
                                    listcid.push( item.id);
                            }
                   
                    })
               })
                 
                 this.pagerequest.listcid=listcid.toString();
              }



            this.pagerequest.type=1;
             
             var starttime=""; 
     var endtime ="";
     if (this.pagerequest.ordtime.length > 0) {
       starttime=this.pagerequest.ordtime[0];
    }
    if (this.pagerequest.ordtime.length > 1) {
     endtime =this.pagerequest.ordtime[1];
    }
 this.pagerequest.stime=starttime;
     this.pagerequest.etime=endtime;
          
      
      await this.$store.dispatch({
                type:'ordermanagement/getStatisticsDataCompanyInformationTimeInput',
                data:this.pagerequest
            })
        let lt=this.$store.state.ordermanagement.ykcflist;
         
             
 
      if(lt!=null){       
       
            
            
			   	require.ensure( [], () => {
					const { export_json_to_excel } = require('@/lib/excel/export2Excel.js');
          
					// 这里深拷贝，修改值时不会影响到原对象
				/*
					lt.map((item) => { // 这里修改要下载的字段内容
				 
					  return item;
					});*/
        
   

  
				 
					  //省份	市区	区县	乡镇
    
					const filterVal = ['name','province','city','county','villages', 'weight','count'];// 取出要下载的表头字段
					const tHeader = ['公司名称','省份','市区','区县','乡镇','总重量','总次数'];// 把表头字段定义成想要的中文或英文
					const data = this.formatJson(filterVal, lt);
					  export_json_to_excel(tHeader, data, '入库数据统计');// 定义excel下载成功的表名
					});			
								
             }

        }

			formatJson(filterVal, jsonData) {
			     return jsonData.map(v => filterVal.map(j => v[j]))
			}
    }
